<template>
  <div v-bind:class="hideArrows">
    <carousel ref="carousel" :paginationEnabled=false
              :navigationEnabled=showArrows
              :navigationNextLabel='`<i class="fa fa-chevron-right fa-3x" aria-hidden="true"></i>`'
              :navigationPrevLabel='`<i class="fa fa-chevron-left fa-3x" aria-hidden="true"></i>`'
              :perPageCustom="perPageCustom"
              :scrollPerPage=false>
      <slide v-for="result in searchResults" :key="result.id">
        <component v-bind:is="cardType" v-bind:data="result"></component>
      </slide>
    </carousel>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel'
import HomeCard from '../home/homeSearch/rightSide/HomeCard.vue'
import ServiceCard from '../marketplace/ServiceCard.vue'

export default {
  components: {
    Carousel,
    HomeCard,
    Slide,
    ServiceCard
  },
  data () {
    return {
      width: 0,
      showArrows: true
    }
  },
  props: {
    searchResults: Array,
    cardType: String
  },
  computed: {
    hideArrows () {
      if (this.width > 650) {
        return 'homapt-carousel-wrapper'
      } else {
        return ''
      }
    },
    perPageCustom () {
      if (this.cardType === 'home-card') {
        return [[0, 1], [1250, 2], [1750, 3], [2250, 4]]
      }
      return [[0, 1], [400, 1], [768, 2], [1250, 3], [1750, 4], [2250, 5], [2750, 6], [3250, 7]]
    }
  },
  watch: {
    width: function (width) {
      if (width > 650) {
        this.showArrows = true
      } else {
        this.showArrows = false
      }
    }
  },
  mounted () {
    window.addEventListener('resize', this.getWidth)
    this.getWidth()
  },
  methods: {
    getWidth (event) {
      this.width = window.innerWidth
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.getWidth)
  }
}
</script>

<style scoped>
.homapt-carousel-wrapper {
 margin-right: 2rem;
 margin-left: 2rem;
 padding-right: 1rem;
 padding-left: 1rem;
}

.VueCarousel-slide {
 margin-bottom: 2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/general/DataCardCarousel.vue